export default __webpack_public_path__ + "fe8974e4f8302acbcf37dc0fc506a5d8.webp";